import { css } from '@emotion/react';
import React from 'react';
import { useHistory } from 'react-router';
import {BtnBorder} from './buttons';

import {Wrap, Float} from './common';

import config from '../config';

export default function ErrorPage({message}) {
  const history = useHistory();
  return (
    <>
      <Wrap>
        <Float>
          <div css={css`font-size: 32px; margin: 0 0 30px;`}>{message}</div>
          <BtnBorder name="トップに戻る" action={() => location.href = config.base + '/'}/>
        </Float>
      </Wrap>
    </>
  );
};
